import AddPlus from 'Assets/images/AddPlus'
import React from 'react'

const NoRecordAddDetails = ({ onClick, title }) => {
    return (
        <div onClick={onClick ? onClick : null} style={{ cursor: "pointer", textAlign: "center", borderRadius: "12px" }}>
            <div style={{ backgroundColor: "#eaeff5", padding: "24px", borderRadius: "12px" }} className='d-flex gap-2 align-items-center justify-content-center'>
                <span style={{ color: "#315D99" }}>{title}</span>
                <AddPlus />
            </div>
        </div>
    )
}

export default NoRecordAddDetails